import type { ImportRowErrorMessage } from './types'

export function formatImportRowError(error: ImportRowErrorMessage | null | undefined): string {
  if (error == null) return ''
  if (typeof error === 'string') return error

  if (Array.isArray(error)) {
    return error
      .map((entry) => {
        if (typeof entry === 'string') return entry
        const column = entry.column ? `${entry.column}: ` : ''
        return `${column}${entry.message}`
      })
      .join('; ')
  }

  if (typeof error === 'object') {
    return Object.entries(error)
      .flatMap(([key, value]) => {
        if (Array.isArray(value)) return value.map((message) => `${key}: ${message}`)
        return [`${key}: ${value}`]
      })
      .join('; ')
  }

  return String(error)
}

export function toImportTypeSlug(importType: string): string {
  return importType.replace(/_/g, '-')
}

export function downloadBlob(blob: Blob, filename: string): void {
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = filename
  link.click()
  window.URL.revokeObjectURL(link.href)
}

export function formatImportDuration(startedAt?: string | null, completedAt?: string | null): string {
  if (!startedAt || !completedAt) return '—'

  const start = new Date(startedAt).getTime()
  const end = new Date(completedAt).getTime()
  if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) return '—'

  const totalSeconds = Math.floor((end - start) / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return [hours, minutes, seconds].map((part) => String(part).padStart(2, '0')).join(':')
}
